import React from 'react';
import SelexSolNavbar from "./CommonC/SelexSolNavbar";

function SelexStudioThree() {
  return (
    <div>
         <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")}/>

         <iframe
      src="/SelexStudio/index3.html"
      width="100%"
      height="750px"
      style={{ border: "none" }}
      title="HTML Page"
    />
    </div>
  )
}

export default SelexStudioThree